import React, {useContext, useEffect, useState, useCallback} from 'react';
import { useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import TextControl from '../components/customizedInputs/TextControl';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';

const CambioClave = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [claves, setClaves] = useState({
    password: "",
    new_password: "",
    new_password_repeated: ""
  });

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true /* && authInformation.rol === 'Admin' */ ){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const cambiarClave = async () => {
    try {
      await resourcesServices.actualizarResource('usuarios', 'cambiarClave', claves);
      navigate(`/salir`);

    } catch (error) {
      errorMessage(error)
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setClaves({...claves,
      [name]: value
    })
  }


  const handleFormSubmit = (e) => {
    e.preventDefault()
    cambiarClave()
  }

  return (
    <div>
      {renderHTML && (
        <>
        <h1>Cambio de clave <BotonVolver /></h1>
        <div className="card">
          <div className="card-body px-0 pb-2 ms-3 me-3">
          {/* <pre>{JSON.stringify(usuario, null, 2)}</pre> */}
            <form onSubmit={handleFormSubmit}>
              <div className='row mb-3'>
                <div className='col-sm-7'>
                  <TextControl
                    value={claves.password}
                    name={'password'}
                    handleInput={handleInput}
                    type='password'
                    label='Clave actual'
                    />
                </div>
                <div className='col-sm-7'>
                  <TextControl
                    value={claves.new_password}
                    name={'new_password'}
                    handleInput={handleInput}
                    type='password'
                    label='Clave nueva'
                    />
                </div>
                <div className='col-sm-7'>
                  <TextControl
                    value={claves.new_password_repeated}
                    name={'new_password_repeated'}
                    handleInput={handleInput}
                    type='password'
                    label='Repita la clave nueva'
                    />
                </div>
              </div>

              <button className="btn btn-primary mt-3" type="submit">Guardar</button>
            </form>
          </div>
        </div>
        </>

      )}
      {/* <AlertaModal alerta={notificacionElegida} /> */}
    </div>
  );
};

export default CambioClave;